<template>
  <div id="userInfo">
    <el-row :gutter="15" type="flex" justify="left">
      <el-form
        ref="elForm"
        size="medium"
        label-width="100px"
        style="margin-left: 200px;"
      >
        <el-col :span="24">
          <el-row>
            <el-col :span="24">
              <el-form-item label="账户名">
                <el-input
                  v-model="nickName"
                  placeholder="请输入账户名"
                  readonly
                  prefix-icon="el-icon-user-solid"
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="注册日期">
                <el-input
                  placeholder=""
                  v-model="regDate"
                  readonly
                  prefix-icon="el-icon-date"
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"> </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="下载点数">
                <el-input
                  placeholder=""
                  v-model="uaDownloadPoints"
                  readonly
                  prefix-icon="el-icon-postcard"
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="12">
              <el-form-item label="开始日期">
                <el-input
                  placeholder=""
                  v-model="uaStartDate"
                  readonly
                  prefix-icon="el-icon-date"
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="~  结束日期">
                <el-input
                  placeholder=""
                  v-model="uaEndDate"
                  readonly
                  prefix-icon="el-icon-date"
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>

<script>
export default {
  mounted () {
    this.getInfo()
  },
  data () {
    return {
      nickName: '',
      realName: '',
      userTel: '',
      userDepartment: '',
      userGender: '',
      regDate: '',
      userEmail: '',
      uaDownloadPoints: 0,
      uaStartDate: null,
      uaEndDate: null,
      userGenderOptions: [
        {
          label: '男',
          value: true
        },
        {
          label: '女',
          value: false
        }
      ]
    }
  },
  methods: {
    millDateToYMDdate (mill) {
      const d = new Date(mill).toLocaleString()
      return d
    },
    getInfo () {
      const api = '/md/front/user/loadInfo'
      this.axios.post(api).then(res => {
        const vobj = res.data
        if (res.status === 200) {
          // 成功 // 这个函数返回的判断标志位是flag, 没有问题
          const user = vobj.info
          this.nickName = user.userNickName
          this.realName = user.userRealName
          this.userTel = user.userPhoneNum
          this.userDepartment = user.userDepartment
          this.userGender = user.userGender
          this.regDate = this.millDateToYMDdate(user.userCreateDate)
          var shouQuan = vobj.shouquan

          this.uaDownloadPoints = shouQuan.uaDownloadPoints
          this.uaStartDate = this.millDateToYMDdate(shouQuan.uaStartDate)
          this.uaEndDate = this.millDateToYMDdate(shouQuan.uaEndDate)
        }
      })
    }
  }
}
</script>
<style scoped>
#userInfo {
  padding-top: 80px;
}

#userInfo :deep(.el-form-item__label) {
  color: #fff;
}

#userInfo :deep(.el-radio) {
  color: #fff;
}

#userInfo :deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #fff;
}

#userInfo :deep(.el-input__inner) {
  background-color: transparent;
  color: #fff;
}
</style>
